var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05728 2.33473C0.894969 2.17242 0.894969 1.90926 1.05728 1.74695L1.81515 0.989076C1.97747 0.826763 2.24063 0.826763 2.40294 0.989075L13.2769 11.8631C13.4393 12.0254 13.4393 12.2886 13.2769 12.4509L12.5191 13.2087C12.3568 13.3711 12.0936 13.3711 11.9313 13.2087L1.05728 2.33473Z",
    fill: "url(#paint0_linear_420_125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9324 0.803375C12.0947 0.641063 12.3579 0.641063 12.5202 0.803375L13.278 1.56125C13.4404 1.72356 13.4404 1.98672 13.278 2.14903L2.40403 13.023C2.24172 13.1854 1.97856 13.1854 1.81625 13.023L1.05837 12.2652C0.896061 12.1029 0.896061 11.8397 1.05837 11.6774L11.9324 0.803375Z",
    fill: "url(#paint1_linear_420_125)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_125",
    x1: 0.935547,
    y1: 7.00606,
    x2: 13.3998,
    y2: 7.00606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_125",
    x1: 0.935547,
    y1: 7.00606,
    x2: 13.3998,
    y2: 7.00606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18AA00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneClose);
export default __webpack_public_path__ + "static/media/done_close.d4bae8b8c80bf9fabc11f309f77d4c68.svg";
export { ForwardRef as ReactComponent };